import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';

@Injectable({
  providedIn: 'root'
})
export class CcPortalService {
  lineUrl = appUrls.lineDetails;
  ticketUrl = appUrls.tickets;
  constructor(private http: HttpClient) { }

  //getLineSummaryByLineId(lineId: number) {
  //  return this.http.get(this.lineUrl.ccLineSummery + lineId);
  //}

  //getTicketByLineQuoteId(lineObject, lineId: number) {
  //  return this.http.post(this.ticketUrl.getTicketsByQuoteId + lineId, lineObject);
  //}
}
